module.exports = __webpack_public_path__ + "img/Sacombank_DKDKSuDungUuDaiGolf-hình ảnh-3.508a3d6d.jpg";